<template>
    <v-container fluid>
        <v-form v-model="valid">
            <v-card :elevation="0">
                <QTextField v-model="supplier.Name" :rules=[requiredRule]
                    :label="$t('servicesystem.common_objects.supplier.name')"></QTextField>
                <v-divider class="my-2"></v-divider>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" :disabled="!valid" @click="create()">
                        {{ $t('servicesystem.common_objects.commonterms.create') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QInputRuleMixin from "@/helpers/Mixins/QInputRuleMixin";
import QTextField from "@/components/Inputs/QTextField.vue";

export default {
    name: 'NewSupplierForm',
    props: {},
    components: {
        QTextField,
    },
    mixins: [QInputRuleMixin],
    data() {
        return {
            valid: false,
            supplier: {
                Name: null
            },
            createSupplierLoading: false
        };
    },

    methods: {
        create() {
            this.createSupplierLoading = true;
            clientAPI.methods.createSupplier(this.supplier)
                .then((response) => {
                    this.$emit('create', response.Id)
                })
                .finally(() => {
                    this.createsupplierLoading = false;
                });
        },
    },
    computed: {},
};
</script>


<style lang='scss' scoped></style>